import "./dateToggleControl.css";
import React from "react";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { FaChevronLeft, FaChevronRight, FaPlus } from "react-icons/fa";
import { IoCalendarOutline, IoList } from "react-icons/io5";
import { useAppContext } from "../../context/AppContext";

function DateToggleControl({
	view,
	data,
	currentMode,
	statusFilter,
	headerDateRange,
	viewBackwardsEvents,
	viewForwardEvents,
	viewingFirstEvent,
	viewingLastEvent,
	handleCreateEvent,
}) {
	const { desktopView } = useAppContext();
	const navigate = useNavigate();

	// Desktop Date:
	const currentDesktopDate = moment().format("D MMM YYYY");

	// Mobile Date:
	const currentMobileDate = moment().format("D");
	const currentMobileDay = moment().format("ddd");
	const currentMobileMonth = moment().format("MMM");
	const currentMobileYear = moment().format("YYYY");

	return (
		<>
			<div className="dateToggleControl_header">
				<div className="dateToggleControl_header_left">
					<div>
						<span>Today</span>
						{desktopView ? (
							<span>{currentDesktopDate}</span>
						) : (
							<span>
								<h1>{currentMobileDate}</h1>
								<span>
									<p>{currentMobileDay}</p>
									<p>
										{currentMobileMonth} {currentMobileYear}
									</p>
								</span>
							</span>
						)}
					</div>
					{view === "Event List" ? (
						<div className="dateToggleControl_header_calendar_nav">
							<FaChevronLeft
								className={`dateToggleControl_header_calendar_nav_btn ${
									viewingFirstEvent ||
									!data?.length ||
									currentMode !== "year" ||
									statusFilter === "happening"
										? "disable"
										: ""
								}`}
								onClick={viewBackwardsEvents}
							/>
							<p>{headerDateRange}</p>
							<FaChevronRight
								className={`dateToggleControl_header_calendar_nav_btn ${
									viewingLastEvent ||
									!data?.length ||
									currentMode !== "year" ||
									statusFilter === "happening"
										? "disable"
										: ""
								}`}
								onClick={viewForwardEvents}
							/>
						</div>
					) : null}
				</div>
				<div
					className={
						view === "Calendar"
							? "calendar_header_right"
							: "dateToggleControl_header_right"
					}
				>
					<IoCalendarOutline
						className={`dateToggleControl_header_calendar_view ${
							view === "Calendar" ? "active" : ""
						}`}
						onClick={() => navigate("/dashboard/calendar")}
					/>
					<IoList
						className={`dateToggleControl_header_list_view ${
							view === "Event List" ? "active" : ""
						}`}
						onClick={() => navigate("/dashboard/event-list")}
					/>

					{view === "Calendar" && desktopView ? (
						<button
							className="calendar_header_new_event_btn"
							onClick={handleCreateEvent}
						>
							<FaPlus className="calendar_header_new_event_btn_icon" /> New
							Event
						</button>
					) : null}
				</div>
			</div>
		</>
	);
}

export default DateToggleControl;
